<template>
  <div
    class="offsetNav"
    v-if="!isAdminView"
  >
    <b-button
      type="button"
      class="shadow-none offsetNav__collapseBtn"
      size="sm"
      variant="secondary"
      v-b-toggle.collapse-offsetNav
    >
      <i
        class="material-icons when-open"
        aria-hidden="true"
      >expand_more</i>
      <i
        class="material-icons when-closed"
        aria-hidden="true"
      >expand_less</i>
    </b-button>
    <b-collapse
      id="collapse-offsetNav"
      visible
    >
      <ul class="offsetNav__list">
        <li class="offsetNav__item">
          <button
            type="button"
            class="btn btn-sm btn-primary offsetNav__btn--print"
            @click.prevent="printPdf()"
          >
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor"><path d="M0 0h24v24H0z" fill="none"/><path d="M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z"/></svg>
            <br>{{ $t('actions.print') }}
          </button>
        </li>
        <li class="offsetNav__item">
          <button
            type="button"
            class="btn btn-sm btn-primary offsetNav__btn--pdf"
            @click.prevent="openPdf()"
          >
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor"><path d="M0 0h24v24H0z" fill="none"/><path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm-1 4l6 6v10c0 1.1-.9 2-2 2H7.99C6.89 23 6 22.1 6 21l.01-14c0-1.1.89-2 1.99-2h7zm-1 7h5.5L14 6.5V12z"/></svg>
            <br>{{ $t('actions.pdf') }}
          </button>
        </li>
        <li class="offsetNav__item">
          <button
            type="button"
            class="btn btn-sm btn-primary offsetNav__btn--respond"
            @click.prevent="replyMail()"
          >
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor"><path d="M0 0h24v24H0z" fill="none"/><path d="M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"/></svg>
            <br>{{ $t('actions.reply') }}
          </button>
        </li>
        <li class="offsetNav__item">
          <button
            type="button"
            class="btn btn-sm btn-primary offsetNav__btn--forward"
            @click.prevent="forwardMail()"
          >
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor"><path d="M0 0h24v24H0z" fill="none"/><path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>
            <br>{{ $t('actions.forward') }}
          </button>
        </li>
        <li class="offsetNav__item">
          <button
            type="button"
            class="btn btn-sm btn-primary offsetNav__btn--chat"
            @click.prevent="openChat()"
          >
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor"><path d="M0 0h24v24H0z" fill="none"/><path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z"/></svg>
            <br>{{ $t('actions.liveChat') }}
          </button>
        </li>
      </ul>
    </b-collapse>
  </div>
</template>

<script>

import Auth from '../../misc/Auth.js';
import Config from '../../misc/Config.js';
import { mapGetters } from 'vuex';

export default {
  name: "OffsetNav",
  data() {
    return {
      isLoggedIn: false,
      isAdminView: false,
    }
  },
  mounted: function () {
    this.setState();
  },
  computed: {
    ...mapGetters(['offer', 'selectedTab'])
  },
  methods: {
    getPdfPath() {
      return `${this.$route.params.offerHash}${(this.selectedTab) ? '_' + this.selectedTab : ''}`;
    },
    setState() {
      this.isLoggedIn = Auth.isLoggedIn();
      this.isOfferView = this.$router.currentRoute.fullPath.split('/')
        .some(path => path === 'offer');
      this.isAdminView = this.$router.currentRoute.fullPath.split('/')
        .some(path => (path === 'admin'));
      this.is404 = this.$router.currentRoute.fullPath.split('/')
        .some(path => (path === "404"));
    },
    forwardMail() {
      window.open(`mailto:?body=${encodeURIComponent(window.location.origin + '/offer/' + this.offer.hash)}&subject=${encodeURIComponent(this.$t('mail.forwardSubject', { title: this.offer.seminar.title }))}`)
    },
    replyMail() {
      window.open(`mailto:${this.offer.employee.email}?subject=${encodeURIComponent(this.$t('mail.replySubject', { title: this.offer.seminar.title, customerNumber: this.offer.contact.company.ref_id }))}`)
    },
    openPdf() {
      window.open(`${Config.PDF_API_URL}/pdf/${this.getPdfPath()}`);
    },
    printPdf() {
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = `${Config.PDF_API_URL}/pdf/${this.getPdfPath()}`;
      document.body.appendChild(iframe);
      iframe.contentWindow.print();
    },
    openChat() {
      let url = 'https://messenger.providesupport.com/messenger/0af9vnyn0kchv09maiwenbeceg.html';
      window.open(url, '_blank', 'menubar=0,location=0,scrollbars=auto,resizable=1,status=0,width=600,height=550');
    },
  },
};
</script>


<style scoped>
.offsetNav {
  position: fixed;
  bottom: 39%;
  right: 0;
  z-index: 3;
}

@media (min-width:1200px) {
  .offsetNav {
    transform: translateY(0) !important;
  }
}

@media (min-width:1200px) {
  .offsetNav__collapseBtn {
    display: none;
  }
}

@media (max-width:1199px) {
  .offsetNav {
    bottom: 0;
    right: 3.7rem;
    transition: transform .3s ease-in-out;
    will-change: transform;
  }
}

@media (max-width:1199px) {
  .offsetNav__item {
    height: 60px;
    border-bottom: 0;
    border-right: 1px solid rgb(4, 43, 96)
  }

  .offsetNav__item:last-child {
    border-right: 0;
  }

  .offsetNav__item:last-child .btn {
    border-bottom-left-radius: 0;
  }
}

@media (max-width:1199px) {
  .offsetNav__list {
    display: -ms-flexbox;
    display: flex;
  }
}

.offsetNav__list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.offsetNav__item {
  width: 65px;
  display: block;
  border-bottom: 1px solid rgb(4, 43, 96);
}

.offsetNav__item:first-child .btn {
  border-top-left-radius: 0.25rem;
}

.offsetNav__item:last-child .btn {
  border-bottom-left-radius: 0.25rem;
}

.offsetNav__list .btn {
  width: 100%;
  height: 100%;
  border-radius: 0;
  font-size: .6rem;
  line-height: 1.2;

}

.offsetNav__list .btn-primary {
  color: #fff;
  background-color: rgb(4, 43, 96);
  border-color: rgb(4, 43, 96);
  box-shadow: rgb(108 117 125 / 40%) 3px 3px 10px;
}

.offsetNav__list .btn-primary:hover,
.offsetNav__list .btn-primary:active,
.offsetNav__list .btn-primary:focus {
  color: #fff;
  background-color: #1f9191;
  border-color: #1f9191;
}

.offsetNav__item:last-child {
  border-bottom: 0;
}

.offsetNav__collapseBtn {
  position: absolute;
  top: -1.55rem;
  right: 0;
  line-height: 1;
  padding: .2rem .4rem;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.offsetNav__collapseBtn.collapsed>.when-open,
.offsetNav__collapseBtn.not-collapsed>.when-closed {
  display: none;
}
</style>
